<template>
  <div style="height: 100vh; width: 100%">
    <div style="width: 100%; display: none; height: 0%">
      <img id="imageid" :src="profpic" />
      <canvas id="imgCanvas" />
      <pdf-make
        ref="pdfMake"
        style="width: 100%"
        :content="content"
        :pageSize="'A4'"
        :pageOrientation="'portrait'"
        :styles="styles"
        :defaultStyle="defaultStyle"
        :show="true"
        :info="{ title: title }"
        @change="
          (e) => {
            src = e;
          }
        "
      >
      </pdf-make>
    </div>
    <iframe
      id="content-frame"
      :src="src"
      style="width: 100%; display: inline-block; height: 100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import PdfMake from "@/components/PdfMake";
import { docStyles, docDefaultStyle } from "@/data/TemplateSuratKontrol.js";
import { headerImage } from "@/data/headerImage.js";
import { photoPlaceholder } from "@/data/photoPlaceholder.js";
import { labelValueFormatter } from "@/data/helper.js";
// import ttf from 'url-loader!@/assets/微软雅黑.ttf'
//console.log(ttf)
export default {
  name: "DocSuratPeriksaMata",
  components: {
    PdfMake,
  },
  data() {
    return {
      title: "Surat Keterangan Hasil Pemeriksaan Mata",
      src: "",
      content: [],
      styles: docStyles,
      ralan: {},
      defaultStyle: docDefaultStyle,
      profpic: "https://103.27.207.58/backend/public/images/icon_customer.png",
    };
  },
  methods: {
    executeDocument: function() {
      // let doc=document;
      //console.log(doc);
      // setTimeout(() => {
      //     doc.getElementById('content-frame').contentWindow.window.print();
      //     //console.log(doc.getElementById('content-frame'));
      // }, 1000);
      // if(this.src){
      document.getElementById("content-frame").contentWindow.window.print();
      // }
      //console.log(doc.getElementById('content-frame'));
    },
    toDataUrl: function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.ralan = JSON.parse(
      this.CryptoJS.AES.decrypt(
        this.$route.params.slug.replace(/fRWdSl45h/g, "/"),
        this.$store.state.simrsSecretPassphrase
      ).toString(this.CryptoJS.enc.Utf8)
    );
    var draft = {
      title: "SURAT KETERANGAN HASIL PEMERIKSAAN MATA",
      subtitle: "No. : ......../20",
      p1: "Yang bertanda tangan dibawah ini menerangkan bahwa :",
      arr1: [
        { label: "Nama Pasien", value: this.ralan.pasien.nama },
        { label: "Pekerjaan", value: this.ralan.pasien.pekerjaan },
        { label: "Alamat", value: this.ralan.pasien.alamat },
        { label: "Usia", value: this.ralan.pasien.formatted_umur },
        {
          label: "No. Kartu Identitas",
          value: `${this.ralan.pasien.no_id} ( ${this.ralan.pasien.jenis_id} )`,
        },
      ],
      p2: "Telah dilakukan pemeriksaan mata dengan hasil sebagai berikut :",
      arr2: [
        { label: "1. Tajam Penglihatan ", value: "" },
        {
          label: `	- Mata Kiri`,
          value: `................................. Dengan / Tanpa Kacamata`,
        },
        {
          label: `	- Mata Kanan`,
          value: `................................. Dengan / Tanpa Kacamata
        `,
        },
        {
          label: "2. Penglihatan Warna:",
          value: `Tidak Buta Warna/ Buta Warna/ Buta Warna Parsial (Coret yang tidak perlu)`,
        },
        {
          label: "3. Catatan:",
          value: `
        .................................................................................

        .................................................................................

        .................................................................................`,
        },
      ],
    };
    var sign = `
    Pekanbaru, ________________________

    Tanda tangan Dokter Spesialis Mata
    Dan Stempel Rumah Sakit





    ( ${this.ralan.dokter.nama} )`;
    let arr1 = labelValueFormatter(draft.arr1, 200);
    let arr2 = labelValueFormatter(draft.arr2, 200);
    this.content = [
      {
        image: headerImage,
        width: 529,
      },
      {
        text: draft.title,
        style: "title",
      },
      {
        style: "paragraph",
        text: draft.p1,
      },
      ...arr1,
      {
        style: "paragraph",
        text: draft.p2,
      },
      ...arr2,
      {
        columns: [
          {
            alignment: "right",
            image: photoPlaceholder,
            width: 320,
          },
          {
            style: "sign",
            text: sign,
          },
        ],
      },
    ];
  },
  // watch:{
  //   src:function(){
  //     document.getElementById('content-frame').contentWindow.window.print();
  //   }
  // }
};
</script>
